export { BaseChatsListModule } from './base-chats-list';
